module.exports = __webpack_public_path__ + "static/img/client-3.7a3335e7.png";